export default "__VITE_ASSET__BUgK74M6__"